import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import {
  AppUpdate,
  AppUpdateAvailability
} from '@capawesome/capacitor-app-update';
import { Logger } from '../../utils/logger';
import { APP_ID } from './update.config';

/**
 * App Updater (App Store / Play Store) Component.
 *
 * @exports
 * @class UpdateComponent
 * @implements {AfterViewInit|OnDestroy}
 */
@Component({
  selector: 'app-update',
  template: ``,
  imports: []
})
export class UpdateComponent implements AfterViewInit, OnDestroy {
  private readonly logger = Logger.getInstance(UpdateComponent.name);

  country: string;

  /**
   * Creates an instance of UpdateComponent.
   *
   * @memberof UpdateComponent
   */
  constructor() {
    this.country = `ID`;
  }

  /**
   * Setup.
   *
   * @memberof UpdateComponent
   */
  ngAfterViewInit(): void {
    const logger = this.logger.child(this.ngAfterViewInit.name);

    if (!Capacitor.isNativePlatform()) return;

    AppUpdate.getAppUpdateInfo({ country: this.country })
      .then((info): any => {
        logger.log({ info });

        if (
          info.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE
        ) {
          if (info.immediateUpdateAllowed) {
            return AppUpdate.performImmediateUpdate();
          }
          return AppUpdate.openAppStore({ appId: APP_ID });
        }
        return info;
      })
      .then(logger.log)
      .catch(logger.error);
  }

  /**
   * Cleanup.
   *
   * @memberof UpdateComponent
   */
  ngOnDestroy(): void {
    AppUpdate.removeAllListeners();
  }
}
